import { all, fork, put, takeEvery, takeLatest } from "redux-saga/effects";
import { isEmpty } from "ramda";
import { WorkstationActionTypes } from "./types";
import { fetch, save, drop } from "../../repo/workstation";
import {
  fetchRequest,
  fetchError,
  fetchSuccess,
  saveRequest,
  saveSuccess,
  saveError,
  deleteRequest,
  deleteSuccess,
  deleteError,
} from "./actions";
import { isAuthError } from "../";
import { dirty } from "../session/actions";

function* handleFetch(action: ReturnType<typeof fetchRequest>) {
  try {
    const group = yield fetch(action.payload.id, action.payload.params);
    if (group.errors && !isEmpty(group.errors)) {
      if (isAuthError(group.errors)) {
        yield put(dirty());
      }
      yield put(fetchError(JSON.stringify(group.errors)));
    } else {
      yield put(fetchSuccess(group));
    }
    yield put(fetchSuccess(group));
  } catch (err) {
    yield put(fetchError(err));
  }
}

function* watchFetchRequest() {
  yield takeEvery(WorkstationActionTypes.FETCH, handleFetch);
}

function* handleSave(action: ReturnType<typeof saveRequest>) {
  try {
    const ws = yield save(action.payload.data);
    // we may still have an error
    // if so then we should yield error
    if (ws.errors && !isEmpty(ws.errors)) {
      if (isAuthError(ws.errors)) {
        yield put(dirty());
      }
      yield put(saveError(JSON.stringify(ws.errors)));
      let errorMsg = ws.errors[0].detail;
      if (ws.errors[0].detail && ws.errors[0].detail.includes('E11000 duplicate key')) {
        errorMsg = 'Duplicate WorkstationId';
      }
      action.payload.callback && action.payload.callback(errorMsg, null);
    } else {
      yield put(saveSuccess(ws));
      action.payload.callback && action.payload.callback(null, ws);
    }
  } catch (err) {
    yield put(saveError(err));
    action.payload.callback &&
      action.payload.callback(
        "An error occurred while saving Workstation",
        null
      );
  }
}

function* watchSaveRequest() {
  yield takeEvery(WorkstationActionTypes.SAVE_REQUEST, handleSave);
}

function* handleDelete(action: ReturnType<typeof deleteRequest>) {
  try {
    const dropResponse = yield drop(action.payload.id);
    if (dropResponse.errors && !isEmpty(dropResponse.errors)) {
      if (isAuthError(dropResponse.errors)) {
        yield put(dirty());
      }
      yield put(deleteError(JSON.stringify(dropResponse.errors)));
      action.payload.callback && action.payload.callback(dropResponse.errors);
    } else {
      yield put(deleteSuccess());
      action.payload.callback && action.payload.callback(null);
      yield put(fetchRequest(null));
    }
  } catch (err) {
    yield put(deleteError(err));
    action.payload.callback && action.payload.callback(err);
  }
}

function* watchDeleteRequest() {
  yield takeLatest(WorkstationActionTypes.DELETE_REQUEST, handleDelete);
}
export default function* workstationSaga() {
  yield all([
    fork(watchFetchRequest),
    fork(watchSaveRequest),
    fork(watchDeleteRequest),
  ]);
}
